<template>
  <div class="hello" style="background-color: #fff; min-height: 100vh">
    <!-- <div style="padding: 20px 20px">
      <van-image
        width="100%"
        radius="10px"
        :src="require('../assets/picture/zsyz-bg.png')"
      />
      <div>
        <van-row type="flex" justify="end">
          <van-col span="4">
            <select
              v-model="selectYear"
              @change="selectChange($event)"
              class="selectClass"
            >
              <option
                v-for="(item, index) in selectYearsColumns"
                :key="index"
                :value="item"
              >
                {{ item }}
              </option>
            </select>
          </van-col>
        </van-row>
      </div>

      <van-row type="flex" justify="space-between" style="flex-wrap: wrap">
        <van-col
          span="11"
          class="flex-xc-yc"
          :style="
            'background-color:' +
              item.color +
              '; border-radius: 4px; margin-top: 20px; height: 70px; padding: 6px 6px;'
          "
          v-for="(item, index) in zsyzDataAll"
          :key="index"
          @click="clickMethod(item.activeName)"
        >
          <div
            style="
              font-size: 16px;
              font-weight: 400;
              color: #fff;
              text-align: center;
            "
          >
            {{ item.name }}
          </div>
        </van-col>
      </van-row>
      <div
        v-for="(item, index) in zsyzDataAll"
        :key="index"
        v-show="item.activeName == active"
      >
        <div class="cardBackground" v-if="item.name == '稳商扩资'">
          <div
            v-for="(item2, index2) in item.quarterList"
            :key="index2 + '' + index"
            :style="{ backgroundColor: `${item.color}` }"
            @click="
              OpenDetail(
                item.tableConfig,
                item2.tableData,
                item.title,
                item.subTitle,
                item2.quarter
              )
            "
          >
            {{ item2.quarter }}
          </div>
        </div>
        <div class="cardBackground_zsyz" v-else>
          <div
            v-for="(item2, index2) in item.quarterList"
            :key="index2 + '' + index"
            :style="{ backgroundColor: `${item.color}` }"
            @click="
              OpenDetail_zsyz(
                item.tableConfig,
                item2.tableData_qiatan,
                item2.tableData_luodi,
                item.title,
                item.subTitle,
                item2.quarter
              )
            "
          >
            {{ item2.quarter }}
          </div>
        </div>
      </div>
    </div> -->

    <!-- 表格图表弹窗 -->
    <van-dialog
      v-model="showZsyz"
      :showConfirmButton="false"
      style="width: 95%; height: calc(100% - 90px)"
    >
      <!-- 最顶部标题 -->
      <div class="tableTitleClass">
        {{ tableTitle }}
      </div>
      <div
        style=" color: #aaa;font-size: 10px; text-align: left; padding-left: 40px;"
      >
        {{ subTableTitle }}
      </div>
      <div style="color:#000; font-weight:700">
        {{ selectYear + '年 ' + currentQuarter }}
      </div>

      <!-- 稳商扩资表格区域 -->
      <div v-if="tableTitle == '北仑区稳商扩资项目情况'">
        <div v-if="tableData.length > 0" class="componentTable">
          <table border="1" class="tableClass">
            <thead>
              <tr v-for="i in level" :key="i">
                <th
                  v-for="(item, j) in tableConfig.columns"
                  :key="i + ' ' + j"
                  :rowspan="item.rowSpan"
                  :colspan="item.colSpan"
                >
                  <span v-html="item.text"></span>
                </th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(item, i) in tableData" :key="i">
                <td
                  v-for="(thItem, j) in tableConfig.columns.filter(x => x.key)"
                  :key="j"
                >
                  <span>
                    {{
                      thItem.key == 'wskzRanking'
                        ? i + 1
                        : thItem.key == 'zsyzRanking'
                        ? i == 0
                          ? '牵头单位不参与排名'
                          : i
                        : item[thItem.key]
                    }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 没有数据显示 -->
        <div
          style="height: 20px; color: darkgoldenrod; margin-top: 60px"
          v-else
        >
          暂无数据
        </div>
      </div>

      <!-- 招商引资表格区域 -->
      <van-tabs
        v-model="active_zysz"
        v-if="tableTitle == '北仑区招商引资项目情况'"
        color="#26A4DE"
      >
        <van-tab title="新洽谈">
          <div v-if="tableData_qiatan.length > 0" class="componentTable_zsyz">
            <table border="0" class="tableClass">
              <thead>
                <tr v-for="i in level" :key="i">
                  <th
                    v-for="(item, j) in tableConfig.qiatan.columns"
                    :key="i + ' ' + j"
                    :rowspan="item.rowSpan"
                    :colspan="item.colSpan"
                  >
                    <span v-html="item.text"></span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in tableData_qiatan" :key="i">
                  <td
                    v-for="(thItem, j) in tableConfig.qiatan.columns.filter(
                      x => x.key
                    )"
                    :key="j"
                  >
                    <span>
                      {{
                        thItem.key == 'wskzRanking'
                          ? i + 1
                          : thItem.key == 'zsyzRanking'
                          ? i == 0
                            ? '牵头单位不参与排名'
                            : i
                          : item[thItem.key]
                      }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- 没有数据显示 -->
          <div
            style="height: 20px; color: darkgoldenrod; margin-top: 60px"
            v-else
          >
            暂无数据
          </div>
        </van-tab>
        <van-tab title="新落地">
          <!-- 招商引资表格区域 -->
          <div v-if="tableData_luodi.length > 0" class="componentTable_zsyz">
            <table border="1" class="tableClass">
              <thead>
                <tr v-for="i in level" :key="i">
                  <th
                    v-for="(item, j) in tableConfig.luodi.columns"
                    :key="i + ' ' + j"
                    :rowspan="item.rowSpan"
                    :colspan="item.colSpan"
                  >
                    <span v-html="item.text"></span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in tableData_luodi" :key="i">
                  <td
                    v-for="(thItem, j) in tableConfig.luodi.columns.filter(
                      x => x.key
                    )"
                    :key="j"
                  >
                    <span>
                      {{
                        thItem.key == 'wskzRanking'
                          ? i + 1
                          : thItem.key == 'zsyzRanking'
                          ? i == 0
                            ? '牵头单位不参与排名'
                            : i
                          : item[thItem.key]
                      }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- 没有数据显示 -->
          <div
            style="height: 20px; color: darkgoldenrod; margin-top: 60px"
            v-else
          >
            暂无数据
          </div>
        </van-tab>
      </van-tabs>

      <div
        style="
          position: absolute;
          bottom: 0px;
          width: 100%;
          height: 45px;
          line-height: 45px;
          background-color: #007acc;
        "
        @click="CloseDetail"
      >
        关闭
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { ApiGetZSYZ_6, ApiGetWSKZ_6 } from '@/api/zsyz.js'
import { getDict } from '../api/zdqd.js'

export default {
  name: 'zsyz',
  data() {
    return {
      active_zysz: 0,
      showZsyz: true,
      active: '',
      tableDataObj: null,
      tableConfig: {},
      tableData: [],
      tableData_qiatan: [],
      tableData_luodi: [],
      tableTitle: '',
      subTableTitle: '',
      currentQuarter: '',
      level: 1,
      selectYear: process.env.VUE_SELECT_YEAR,
      // selectYear: new Date().getFullYear(),
      // 后台获取的年份列表
      selectYearsColumns: [],
      zsyzDataAll: []
    }
  },
  components: {},
  async created() {
    // 通过后台配置的字典，拿到年份
    // getDict('selectyear_list').then(res => {
    //   res.data.content.forEach(x => {
    //     this.selectYearsColumns.push(x.label)
    //   })
    // })
    await this.getZSYZDataFn(this.$route.query.year)
    if (this.$route.query.type == 'zsyz') {
      if (this.$route.query.month == 3) {
        this.OpenDetail_zsyz(
          this.zsyzDataAll[0].tableConfig,
          this.zsyzDataAll[0].quarterList[0].tableData_qiatan,
          this.zsyzDataAll[0].quarterList[0].tableData_luodi,
          this.zsyzDataAll[0].title,
          this.zsyzDataAll[0].subTitle,
          this.zsyzDataAll[0].quarterList[0].quarter
        )
      } else if (this.$route.query.month == 6) {
        this.OpenDetail_zsyz(
          this.zsyzDataAll[0].tableConfig,
          this.zsyzDataAll[0].quarterList[1].tableData_qiatan,
          this.zsyzDataAll[0].quarterList[1].tableData_luodi,
          this.zsyzDataAll[0].title,
          this.zsyzDataAll[0].subTitle,
          this.zsyzDataAll[0].quarterList[1].quarter
        )
      }
    } else if (this.$route.query.type == 'wskz') {
      if (this.$route.query.month == 3) {
        this.OpenDetail(
          this.zsyzDataAll[1].tableConfig,
          this.zsyzDataAll[1].quarterList[0].tableData,
          this.zsyzDataAll[1].title,
          this.zsyzDataAll[1].subTitle,
          this.zsyzDataAll[1].quarterList[0].quarter
        )
      } else if (this.$route.query.month == 6) {
        this.OpenDetail(
          this.zsyzDataAll[1].tableConfig,
          this.zsyzDataAll[1].quarterList[1].tableData,
          this.zsyzDataAll[1].title,
          this.zsyzDataAll[1].subTitle,
          this.zsyzDataAll[1].quarterList[1].quarter
        )
      }
    }
  },
  methods: {
    async getZSYZDataFn(selectYear) {
      const res = await ApiGetZSYZ_6({ years: selectYear })
      const res2 = await ApiGetWSKZ_6({ years: selectYear })
      this.zsyzDataAll = [
        {
          name: '招商引资',
          activeName: 'zsyz',
          color: '#6AA7F8',
          quarterList: [
            {
              quarter: '第一季度',
              tableData_qiatan: [],
              tableData_luodi: []
            },
            {
              quarter: '上半年',
              tableData_qiatan: [],
              tableData_luodi: []
            },
            {
              quarter: '前三季度',
              tableData_qiatan: [],
              tableData_luodi: []
            },
            {
              quarter: '下半年',
              tableData_qiatan: [],
              tableData_luodi: []
            }
          ],
          tableConfig: {
            qiatan: {
              columns: [
                { text: '排名', key: 'zsyzRanking' },
                { text: '部门', key: 'sectionName' },
                { text: '新洽谈数量（个）', key: 'quantity' },
                { text: '新洽谈总投资（亿元）', key: 'invest' }
              ]
            },
            luodi: {
              columns: [
                { text: '排名', key: 'zsyzRanking' },
                { text: '部门', key: 'sectionName' },
                { text: '新落地数量（个）', key: 'quantity' },
                { text: '新落地总投资（亿元）', key: 'invest' }
              ]
            }
          },
          title: '北仑区招商引资项目情况',
          subTitle: '完成情况表'
        },
        {
          name: '稳商扩资',
          activeName: 'wskz',
          color: '#65C9BD',
          quarterList: [
            {
              quarter: '一季度',
              tableData: []
            },
            {
              quarter: '二季度',
              tableData: []
            },
            {
              quarter: '三季度',
              tableData: []
            },
            {
              quarter: '四季度',
              tableData: []
            },
            {
              quarter: '全年度',
              tableData: []
            }
          ],
          tableConfig: {
            columns: [
              { text: '排名', key: 'wskzRanking' },
              { text: '名称', key: 'name' },
              { text: '前期准备数量（个）', key: 'reserveQuantity' },
              { text: '前期准备总投资（亿元）', key: 'readyToInvest' },
              { text: '已开工数量（个）', key: 'quantityStarted' },
              { text: '已开工总投资（亿元）', key: 'quantityInvest' },
              { text: '谋划数量', key: 'planQuantity' },
              { text: '谋划总投资（亿元）', key: 'planInvest' },
              { text: '合计总投资（亿元）', key: 'total' }
            ]
          },
          title: '北仑区稳商扩资项目情况',
          subTitle: '完成情况表'
        }
      ]
      // 招商引资
      // 落地
      res.data.freshLanding.forEach(x => {
        this.zsyzDataAll[0].quarterList.forEach(x2 => {
          if (x.season == x2.quarter) {
            x2.tableData_luodi.push(x)
          }
        })
      })
      // 洽谈
      res.data.newNegotiation.forEach(x => {
        this.zsyzDataAll[0].quarterList.forEach(x2 => {
          if (x.season == x2.quarter) {
            x2.tableData_qiatan.push(x)
          }
        })
      })
      // 稳商扩资
      res2.data.steady.forEach(x => {
        this.zsyzDataAll[1].quarterList.forEach(x2 => {
          if (x.season == x2.quarter) {
            x2.tableData.push(x)
          }
        })
      })
    },
    clickMethod(id) {
      this.active = id
    },
    CloseDetail() {
      this.showZsyz = false
      this.$router.go(-1)
    },
    // 稳商扩资数据显示
    OpenDetail(tableConfig, tableData, tableTitle, subTableTitle, quarter) {
      this.currentQuarter = quarter
      this.tableConfig = tableConfig
      this.tableData = tableData
      this.subTableTitle = subTableTitle
      this.tableTitle = tableTitle
      this.getColumnConfig(tableConfig.columns, 1)
      this.showZsyz = true
    },
    // 招商引资数据显示
    OpenDetail_zsyz(
      tableConfig,
      tableData_qiatan,
      tableData_luodi,
      tableTitle,
      subTableTitle,
      quarter
    ) {
      this.tableConfig = tableConfig
      this.tableData_qiatan = tableData_qiatan
      this.tableData_luodi = tableData_luodi
      this.currentQuarter = quarter
      this.subTableTitle = subTableTitle
      this.tableTitle = tableTitle
      this.getColumnConfig(tableConfig.qiatan.columns, 1)
      this.showZsyz = true
    },
    getColumnConfig(columns, level) {
      if (level > this.level) {
        this.level = level
      }
      columns.forEach(item => {
        // 合并行属性
        item.rowSpan = 1
        // 合并列属性
        item.colSpan = 1
      })
    },
    selectChange(e) {
      this.selectYear = e.target.value
      this.getZSYZDataFn(this.selectYear)
    }
  }
}
</script>

<style scoped>
/* 稳商扩资样式 */
.componentTable {
  overflow-y: scroll;
  overflow-x: scroll;
  margin: 20px;
  padding-left: 1px;
  width: 85vw;
  height: 65vh;
  border: 1px solid #e1ebf7;
  border-top: 0;
}
.componentTable .tableClass {
  color: #333;
  border-collapse: collapse;
  font-size: 14px;
  border: 1px solid #e1ebf7;
  border-left: 0;
}
/* 头部单元格不换行,左边第一，第二列不换行 */
.componentTable .tableClass thead tr th {
  padding: 5px;
  white-space: nowrap;
}
/* 给左边第一列一个固定宽度 */
.componentTable .tableClass thead tr th:nth-child(1) span,
.componentTable .tableClass tbody tr td:nth-child(1) span {
  display: inline-block;
  width: 30px;
  padding: 5px;
}
/* 悬浮第一列和第二列，并给轮廓线 */
.componentTable .tableClass thead tr th:nth-child(1),
.componentTable .tableClass tbody tr td:nth-child(1),
.componentTable .tableClass thead tr th:nth-child(2),
.componentTable .tableClass tbody tr td:nth-child(2) {
  position: sticky;
  left: 0;
  background-color: #fff;
  border: none;
  outline-color: #e1ebf7;
  outline-style: solid;
  outline-width: 1px;
}
/* 左边第二列偏移70px */
.componentTable .tableClass thead tr th:nth-child(2),
.componentTable .tableClass tbody tr td:nth-child(2) {
  left: 50px;
}
.componentTable .tableClass thead tr th:nth-child(2) span,
.componentTable .tableClass tbody tr td:nth-child(2) span {
  display: inline-block;
  width: 50px;
}
/* 招商引资样式 */
.componentTable_zsyz {
  overflow: auto;
  margin: 5px 20px 20px 20px;
  width: 85vw;
  height: 60vh;
}
.componentTable_zsyz .tableClass {
  min-width: 100%;
  color: #333;
  border-collapse: collapse;
  font-size: 14px;
  position: relative;
  border: 1px solid #e1ebf7;
  position: relative;
}
.componentTable_zsyz .tableClass thead tr th {
  position: sticky;
  top: 0px;
  background: #fff;
  border: 1px solid #e1ebf7;
}
.componentTable_zsyz .tableClass thead tr th::before {
  content: '';
  width: 100%;
  position: absolute;
  top: -2px;
  left: 0;
  border: 1px solid #e1ebf7;
}
.componentTable_zsyz .tableClass thead tr th::after {
  content: '';
  width: 100%;
  position: absolute;
  bottom: -1px;
  left: 0;
  border: 1px solid #e1ebf7;
}
.componentTable_zsyz .tableClass thead tr th span,
.componentTable_zsyz .tableClass tbody tr td span {
  display: block;
  min-width: 60px;
  padding: 5px;
  /* 强制换行 */
  overflow-wrap: break-word;
}
.componentTable_zsyz .tableClass thead tr th:nth-child(2) span,
.componentTable_zsyz .tableClass tbody tr td:nth-child(2) span {
  width: 80px;
}
.componentTable_zsyz .tableClass tbody tr td {
  border: 1px solid #e1ebf7;
}
.componentTable_zsyz .tableClass tbody tr {
  height: 40px;
}
/* 卡片背景 */
.cardBackground {
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px;
  padding: 10px 5px;
  margin-top: 30px;
  border-radius: 5px;
  display: flex;
  flex-wrap: wrap;
  width: 97%;
  height: 100px;
  position: relative;
}
.cardBackground div {
  border-radius: 5px;
  font-size: 14px;
  color: #fff;
}
.cardBackground div:nth-child(-n + 4) {
  width: 36%;
  height: 46%;
  margin-right: 2%;
  margin-bottom: 2%;
  line-height: 3;
}
.cardBackground div:nth-child(2),
.cardBackground div:nth-child(4) {
  margin-right: 18%;
}
.cardBackground div:last-child {
  position: absolute;
  right: 5px;
  top: 10px;
  width: 20%;
  height: 83%;
  line-height: 7;
}
.cardBackground_zsyz {
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px;
  padding: 10px 5px;
  margin-top: 30px;
  border-radius: 5px;
  display: flex;
  flex-wrap: wrap;
  width: 97%;
  height: 100px;
}
.cardBackground_zsyz div {
  width: 46%;
  border-radius: 5px;
  font-size: 14px;
  color: #fff;
  margin: 0 10px 5px 0;
  line-height: 3;
}
.tableTitleClass {
  height: 22px;
  padding-top: 20px;
  padding-left: 20px;
  font-size: large;
  color: #000;
  font-weight: 700;
  text-align: left;
}
.tableTitleClass::before {
  content: '▍';
  color: #23a4de;
}
</style>



// WEBPACK FOOTER //
// src/components/zsyz-origin.vue